export interface IretStatus {
  status: string;
  msg?: string;
}

export interface IresData {
  code: string;
  msg?: string;
  result?: any;
}

export interface IresData {
  code: string;
  msg?: string;
  result?: any;
}

export interface IbreadcrumbItem {
  name: string;
  path: string;
}

// 1.培训通知 2.会议论坛 3.会员简介 4.会员风采 5.团体标准 6.参考资料 7.会员资讯
export enum Estata {
  'consult' = 7,
  'cultivate' = 1,
  'meeting' = 2,
  'memberintroduction' = 3,
  'membermien' = 4,
  'groupstandards' = 5,
  'referencedata' = 6,
}

export const ElistText: any = {
  consult: '意见征集',
  cultivate: '经济运行分析',
  meeting: '会展活动',
  memberintroduction: '会员专区',
  membermien: '科技团标',
  groupstandards: '教育培训',
  referencedata: '党建工作',
};

export const memberState: any = {
  1: '待确认',
  3: '已拒绝',
  4: '退回修改',
  5: '再次确认',
  };